<header data-cy="header-main" class="header__main flex-row flex-centered">
  <div data-cy="header-menu-icon" class="header__mobile">
    <button mat-icon-button title="menu" (click)="toggleNav()" class="header__mobile__menu-link">
      <mat-icon>{{ switchIcon ? 'close' : 'menu' }}</mat-icon>
    </button>
  </div>

  <div data-cy="header-logo" class="header__main__logo">
    <a [routerLink]="['/']" matTooltip="{{ 'header.logo' | translate }}">
      <mat-icon svgIcon="cm-cloud-imagotype"></mat-icon>
    </a>
  </div>
  <div data-cy="header-user-mobile" class="show--mobile-only header__main__last__account flex-row flex-centered">
    <ng-container *ngTemplateOutlet="userProfilePicture"></ng-container>
  </div>

  <div class="header__main__last">

    <!-- Root Org Selector -->
    <div *ngIf="userService.availableRootOrgs?.length" class="header__main__last__org-selector pr-4">
      <div class="org-selector-dropdown">
        <mat-select [value]="selectedOrg.orgId" (selectionChange)="rootOrgSelected($event)"
                    [attr.data-cy]="'org-selector-dropdown'">
          <mat-option class="cm-dropdown-option typography__menu-item"
                      *ngFor="let option of userService.availableRootOrgs" [value]="option.orgId"
                      [attr.data-cy]="'option-'+option.orgName">
            {{ option.orgName }}
          </mat-option>
        </mat-select>
      </div>
    </div>

    <!-- LAST SECTION -->
    <div class="header__main__last flex-row">
      <!-- NOTIFICATIONS SECTION -->
      <div data-cy="header-notifications"
           id="notificationsTarget"
           class="header__main__last__notifications flex-row flex-centered"
           (click)="openNotifications()">
        <div class="header__main__last__notifications__wrapper">
          <mat-icon inline
                    matTooltip="{{ 'header.notifications' | translate }}"
                    matTooltipPosition="below"
                    matTooltipShowDelay="500"
                    matTooltipHideDelay="500"
                    matTooltipClass="cm-tooltip typography__tooltip">notifications</mat-icon>
          <ng-container *ngIf="notificationsCount$ | async as notificationsCount">
            <span *ngIf="notificationsCount > 0"
                  class="badge-notification"
                  matBadge="{{ notificationsCount }}"
                  matBadgeSize="small"
                  matBadgePosition="after"
                  matBadgeColor="warn">
            </span>
          </ng-container>
        </div>
      </div>
      <!-- ACCOUNT SECTION -->
      <div data-cy="header-user-desktop"
           class="header__main__last__account flex-row flex-centered"
           (click)="openPopOver('profile')">
        <cm-popover data-cy="header-popover"
                    target="#profileTarget"
                    (hiding)="profilePopoverClick = false"
                    [(visible)]="profilePopoverClick"
                    [width]="236">
          <cm-header-profile-popup (closeDialog)="closePopOver('profile')"
                                   (closeImageCroppingMobileEmmiter)="closeImageCroppingMobile()"
                                   [user]="userInfo">
          </cm-header-profile-popup>
        </cm-popover>

        <span class="typography__avatar-initials">{{ userFullName }}</span>
        <div id="profileTarget" class="user-image-container mr-3">
          <ng-container *ngTemplateOutlet="userProfilePicture"></ng-container>
        </div>
      </div>
    </div>

  </div>
</header>

<ng-template #userProfilePicture>
  <div data-cy="user-no-profile-image" class="user-no-profile-image" *ngIf="imageUrlLoading">
    <mat-spinner id="userProfilePictureSpinner"></mat-spinner>
  </div>
  <div *ngIf="!imageUrlLoading && authUrl" class="user-image" (click)="mobile && openMovilSideProfilePicPanel()">
    <img [src]="authUrl" (error)="handleImageError($event)" />
  </div>
  <div class="user-no-profile-image"
       *ngIf="!imageUrlLoading && !userInfo?.imageUrl"
       (click)="mobile && openMovilSideProfilePicPanel()">
    <mat-icon inline>account_circle</mat-icon>
  </div>
</ng-template>

<cm-side-nav #cmSideNav from="right" (closeEmitter)="setInitSideNav()">
  <div style="overflow: hidden" id="sideNavbody">
    <cm-header-profile-popup *ngIf="mobileSideNavStep === 1"
                             [isSideNavStyle]="true"
                             (openImageCroppingMobileEmmiter)="openImageCroppingMobile()"
                             (closeDialog)="!mobile ? closePopOver('profile') : cmSideNavRef.close()"
                             [user]="userInfo">
    </cm-header-profile-popup>
    <div>
      <cm-image-cropping *ngIf="mobileSideNavStep === 2" [isSideNavStyle]="true" (sideNavCloseEmmiter)="closeSideNav()">
      </cm-image-cropping>
    </div>
  </div>
</cm-side-nav>
